import { getValue } from "../../../common/getValue";

export function CUSTOMER_NEW_REQUEST(state) {
  state;
  state.customersNew = {
    ...state.customersNew,
    isLoading: true,
  };
}
export function CUSTOMER_NEW_SUCCESS(state, payload) {
  const data = [];
  payload.data.rows.map((item, idx) => {
    data.push({
      idx: idx,
      id: item.id || "-",
      company_name: getValue(item, "outletName", "-"),
      owner: getValue(item, "ownerFullname", "-"),
      bussines_entity: getValue(item, "companyType", "-"),
      nik: getValue(item, "nik", "-"),
      npwp: getValue(item, "npwp", "-"),
      tlp: getValue(item, "ownerPhoneNumber", "-"),
      status: getValue(item, "status", "-"),
      email_address: getValue(item, "ownerEmail", "-"),
      ship_to: getValue(item, "ship_to", "-"),
      bill_to: getValue(item, "billToAddress", "-"),
    });
    return item;
  });
  state;
  state.customersNew = {
    data: data,
    count: payload.data.count,
    status: payload.status,
    isLoading: false,
  };
}
export function CUSTOMER_NEW_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}

export function GET_CUSTOMER_NEW_REQUEST(state) {
  state;
  state.customerNew = {
    ...state.customerNew,
    isLoading: true,
  };
}
export function GET_CUSTOMER_NEW_SUCCESS(state, payload) {
  const { data } = payload.data.data;
  const dataResponse = {
    company_name: getValue(data, "outletName", "-"),
    owner: getValue(data, "ownerFullname", "-"),
    bussines_entity: getValue(data, "companyType", "-"),
    nik: getValue(data, "nik", "-"),
    npwp: getValue(data, "npwp", "-"),
    tlp: getValue(data, "ownerPhoneNumber", "-"),
    email_address: getValue(data, "ownerEmail", "-"),
    ship_to: {
      country: getValue(data, "country", "-"),
      province: getValue(data, "sendToProvince.province", "-"),
      city: getValue(data, "city", "-"),
      state: getValue(data, "state", "-"),
      address: getValue(data, "sendToAddress", "-"),
      postal_code: getValue(data, "sendToZipCode", "-"),
      phone_number: getValue(data, "primaryPhoneNumber", "-"),
      contact_person: getValue(data, "contactPerson", "-"),
      contact_phone_number: getValue(data, "contactPhoneNumber", "-"),
      village: getValue(data, "sendToVillage.village", "-"),
      district: getValue(data, "sendToDistrict.district", "-"),
    },
    bill_to: {
      country: getValue(data, "country", "-"),
      province: getValue(data, "billToProvince.province", "-"),
      city: getValue(data, "city", "-"),
      state: getValue(data, "state", "-"),
      address: getValue(data, "billToAddress", "-"),
      postal_code: getValue(data, "billToZipCode", "-"),
      phone_number: getValue(data, "primaryPhoneNumber", "-"),
      contact_person: getValue(data, "contactPerson", "-"),
      contact_phone_number: getValue(data, "contactPhoneNumber", "-"),
      village: getValue(data, "billToVillage.village", "-"),
      district: getValue(data, "billToDistrict.district", "-"),
    },
  };
  state;
  state.customerNew = {
    data: dataResponse,
    status: payload.status,
    isLoading: false,
  };
}
export function GET_CUSTOMER_NEW_ERROR(state, payload) {
  state;
  state.customerNew = {
    isLoading: false,
    error: true,
    errorMessage: payload,
  };
}
